export var EnumPageMeta;
(function (EnumPageMeta) {
    EnumPageMeta["title"] = "\u5927\u8054\u60F3\u4F19\u4F34\u7F51\u76F4\u64AD\u95F4";
})(EnumPageMeta || (EnumPageMeta = {}));
/**
 * 字段描述 枚举
 */
export var EnumLocaleLabel;
(function (EnumLocaleLabel) {
})(EnumLocaleLabel || (EnumLocaleLabel = {}));
export var EnumGender;
(function (EnumGender) {
})(EnumGender || (EnumGender = {}));
export default {
    en: {},
    zh: {
        'broadcasting': EnumPageMeta.title,
    },
};
